import axios from 'axios';

const http = axios.create({
  baseURL: `${process.env.NEXT_NEW_API_URL}/public-agents`,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // withCredentials: true,
});

// http.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 401) {
//       console.log('Status 401 received, logging out!!!!');
//       localStorage.removeItem('agentInfo');
//       window.location.href = '/';
//     }
//     return Promise.reject(error);
//   }
// );

export default http;
